import * as React from "react";

export interface SwitchCaseProps {
    visible: boolean;
    children: React.ReactNode;
}

export function SwitchCase(props: SwitchCaseProps): JSX.Element {
    if (!props.visible) {
        return <></>;
    }
    return <>{props.children}</>;
}

export interface SwitchDefaultProps {
    visible: boolean;
    children: React.ReactNode;
}

export function SwitchDefault(props: SwitchDefaultProps): JSX.Element {
    if (!props.visible) {
        return <></>;
    }
    return <>{props.children}</>;
}

export interface SwitchProps {
    children: Array<
        | React.ReactElement<SwitchCaseProps, typeof SwitchCase>
        | React.ReactElement<SwitchDefaultProps, typeof SwitchDefault>
    >;
}

export function Switch(props: SwitchProps): JSX.Element | null {
    return <>{props.children}</>;
}
